export const ExtrasManagementsEnum = {
  EXTRAS_TYPE: 'extras',
  BREAKDOWN_EXTRAS_TYPE: 'breakdownExtras',
} as const;

export type ExtrasManagementsEnum = (typeof ExtrasManagementsEnum)[keyof typeof ExtrasManagementsEnum];
